<template lang="pug">
.preview-item
  .preview-item-header
    .preview-title
      strong {{ preview.preview_title || 'Untitled Preview' }}
    .preview-actions-inline
      a.btn.btn-xs.btn-default(
        v-if="preview.preview_url"
        :href="preview.preview_url"
        target="_blank"
        rel="noopener noreferrer"
        title="Open Adobe preview in new tab"
      )
        i.fa.fa-external-link
      button.btn.btn-xs.btn-default(
        @click="$emit('check-version', preview)"
        :disabled="isFetching || isCheckingVersion"
        title="Refresh this preview"
      )
        i.fa.fa-refresh(v-if="!isCheckingVersion")
        i.fa.fa-spinner.fa-spin(v-else)
      button.btn.btn-xs.btn-danger(
        @click="$emit('delete', preview)"
        :disabled="isFetching"
        title="Delete this preview"
      )
        i.fa.fa-trash
  
  .preview-progress(v-if="isFetching && preview.fetch_status")
    .progress-status
      span {{ statusLabel(preview.fetch_status) }}
      .progress-bar-container
        .progress
          .progress-bar.progress-bar-striped.active(
            role="progressbar"
            :style="{ width: preview.fetch_progress + '%' }"
          )
            | {{ preview.fetch_progress }}%
      .progress-message(v-if="preview.fetch_message")
        small.text-muted {{ preview.fetch_message }}
  
  .preview-info(v-else-if="preview.etag")
    .info-row(v-if="preview.modified_at")
      small
        strong Modified:
        |  {{ formatDate(preview.modified_at) }}
    .info-row(v-if="preview.version")
      small
        strong Version:
        |  {{ preview.version }}
    .info-row(v-if="preview.page_count")
      small
        strong Pages:
        |  {{ preview.page_count }}
    
    PreviewThumbnailGrid(
      v-if="thumbnails.length > 0"
      :preview-id="preview.id"
      :preview-title="preview.preview_title || 'Untitled Preview'"
      :thumbnails="thumbnails"
    )
</template>

<script>
  import PreviewThumbnailGrid from './preview_thumbnail_grid.vue'

  export default {
    components: {
      PreviewThumbnailGrid
    },

    props: {
      preview: {
        type: Object,
        required: true
      },
      isFetching: {
        type: Boolean,
        default: false
      },
      isCheckingVersion: {
        type: Boolean,
        default: false
      },
      thumbnails: {
        type: Array,
        default: () => []
      }
    },

    methods: {
      formatDate(dateString) {
        if (!dateString) return 'N/A'
        return new Date(dateString).toLocaleString()
      },
      
      statusLabel(fetchStatus) {
        const statusMap = {
          'fetching_pdf': 'Downloading PDF...',
          'pdf_complete': 'PDF Downloaded',
          'extracting_pages': 'Analyzing PDF...',
          'generating_thumbnails': 'Generating Thumbnails...',
          'complete': 'Complete',
          'error': 'Error'
        }
        return statusMap[fetchStatus] || 'Processing...'
      }
    }
  }
</script>

<style scoped>
  .preview-item {
    background-color: white;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 0.75rem;
  }

  .preview-item-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1.5rem;
  }

  .preview-title {
    flex: 1;
    word-break: break-word;
    overflow-wrap: break-word;
    min-width: 0;
  }

  .preview-title strong {
    font-size: 14px;
    color: #333;
  }

  .preview-actions-inline {
    display: flex;
    gap: 0;
    margin-left: 1rem;
  }

  .preview-actions-inline .btn {
    padding: 2px 6px;
    font-size: 11px;
  }

  .preview-actions-inline .btn i {
    font-size: 18px;
  }

  .preview-progress {
    margin: 0.5rem 0;
    padding: 0.5rem;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #dee2e6;
  }

  .progress-status {
    font-size: 13px;
  }

  .progress-status span {
    display: block;
    margin-bottom: 0.4rem;
    color: #333;
    font-weight: 500;
  }

  .progress-bar-container {
    margin-bottom: 0.4rem;
  }

  .progress {
    height: 20px;
    margin-bottom: 0;
    background-color: #e9ecef;
  }

  .progress-bar {
    background-color: #337ab7;
    line-height: 20px;
    color: white;
    font-weight: bold;
    font-size: 11px;
    transition: width 0.3s ease;
  }

  .progress-message {
    margin-top: 0.4rem;
  }

  .progress-message small {
    font-style: italic;
    font-size: 11px;
    display: block;
  }

  .preview-info {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
  }

  .info-row {
    font-size: 12px;
    line-height: 1.4;
  }

  .info-row small {
    font-size: 12px;
    font-weight: normal;
    display: block;
  }

  .info-row strong {
    color: #666;
    margin-right: 0.25rem;
  }
</style>
